import gsap from 'gsap';
import imagesLoaded from 'imagesloaded';

export default class Scroll {
  constructor() {
    this.data = {
      last: 0,
      ease: 0.1,
      current: 0,
    };

    this.math = {
      lerp: (a, b, n) => (1 - n) * a + n * b,
    };

    this.config = {
      height: window.innerHeight,
    };

    this.dom = {
      el: document.querySelector('.app'),
      content: document.querySelector('.a-scroll'),
      page: document.querySelector('.a-scroll > div'),
    };

    this.links = {
      team: document.querySelectorAll('.s-team-row'),
    };
  }

  setHeight() {
    document.body.style.height = `${this.dom.page.offsetHeight}px`;
  }

  resize = () => {
    this.setHeight();
    this.scroll();
  }

  preload() {
    imagesLoaded(this.dom.content, () => {
      this.setHeight();
    });
  }

  scroll = () => {
    if (this.data) this.data.current = window.scrollY;
  }

  scrollTo = (e) => {
    window.scroll(0, e.detail.scrollVal);
    if (this.data) this.data.current = window.scrollY;
  }

  run = () => {
    if (this.data) {
      this.data.last = this.math.lerp(this.data.last, this.data.current, this.data.ease);
      if (this.data.last < 0.1) {
        this.data.last = 0;
      }

      this.dom.content.style.transform = `translate3d(0, -${this.data.last}px, 0)`;
    }
  }

  on = () => {
    this.setHeight();
    this.addEvents();
  }

  destroy() {
    document.body.style.height = '';

    this.data = null;

    this.removeEvents();
    gsap.ticker.remove(this.run);
  }

  addEvents() {
    if (this.links.team) {
      [...this.links.team].forEach((el) => {
        el.addEventListener('click', this.off);
      });
    }

    window.addEventListener('resize', this.resize, { passive: true });
    window.addEventListener('scroll', this.scroll, { passive: true });
    window.addEventListener('customScrollTo', this.scrollTo);
  }

  removeEvents() {
    window.removeEventListener('resize', this.resize, { passive: true });
    window.removeEventListener('scroll', this.scroll, { passive: true });
    window.removeEventListener('customScrollTo', this.scrollTo);
  }

  init() {
    this.preload();
    this.on();

    gsap.ticker.add(this.run);
  }

  pause() {
    this.removeEvents();
    gsap.ticker.remove(this.run);
  }

  play() {
    this.addEvents();
    gsap.ticker.add(this.run);
  }
}
